module.exports = __webpack_public_path__ + "static/media/intro3.7ee075c3.png";